import ApiService from './ApiService'

export const getApiData = (data) => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map((sort) => {
            if (!sort.order) return sort
            datas.ordering =
                sort.order === 'desc' ? `-${sort.key}` : `${sort.key}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active' ? true : false
        }
    }
    return ApiService.get('/company/company/', datas)
}
export const createApiRecord = (data) =>
    ApiService.filePost('/company/company/', data)
export const getApiRecord = (id) => ApiService.get(`/company/company/${id}`)
export const updateApiRecord = (id, data) =>
    ApiService.filePut(`/company/company/${id}/`, data)
export const updateApiStatus = (id, data) =>
    ApiService.patch(`/company/company/${id}/`, data)
export const deleteApiRecord = (id) => ApiService.delete('/company/company', id)
export const verifyApiRecord = (id) =>
    ApiService.post(`/company/verify-company/${id}/`)
export const getCompanyTypeApi = (id) =>
    ApiService.get('/company/company-types/')
